
import Layout from '../components/Layout';

const Imprint = () => {
  return (
    <Layout>
      <div className="py-24 bg-gradient-to-b from-white to-pink-50 dark:from-gray-800 dark:to-gray-900">
        <div className="container-custom max-w-3xl">
          <div className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-lg">
            <h1 className="text-3xl font-bold mb-6 text-fembot-pink">Imprint</h1>
            
            <div className="space-y-6 text-gray-700 dark:text-gray-300">
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">Information according to § 5 TMG</h2>
                <p>Nix GmbH</p>
                <p>Schnellerstraße 60</p>
                <p>12439 Berlin</p>
                <p>Germany</p>
              </section>
              
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">Contact</h2>
                <p>Phone: +49 (0) 751 79132 0 </p>
                <p>Email: lunaxxdev@gmail.com</p>
              </section>
              
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">Responsible for content</h2>
                <p>Adrian Hessler</p>
                <p>Schnellerstraße 60</p>
                <p>12439 Berlin</p>
                <p>Germany</p>
              </section>
              
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">EU Dispute Resolution</h2>
                <p>
                  The European Commission provides a platform for online dispute resolution (ODR):
                  <a href="https://ec.europa.eu/consumers/odr/" className="text-fembot-pink hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p className="mt-2">Our email address can be found in the Imprint above.</p>
              </section>
              
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">Consumer Dispute Resolution</h2>
                <p>We are not willing or obligated to participate in dispute resolution proceedings before a consumer arbitration board.</p>
              </section>
              
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">Liability for Contents</h2>
                <p>
                  As service providers, we are liable for our own content on these pages according to general laws. 
                  However, we are not obligated to monitor transmitted or stored third-party information or to investigate
                  circumstances that indicate illegal activity.
                </p>
                <p className="mt-2">
                  Obligations to remove or block the use of information under general laws remain unaffected. 
                  However, liability in this regard is only possible from the moment of knowledge of a specific infringement. 
                  Upon notification of such violations, we will remove the content immediately.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-bold mb-3 dark:text-white">Copyright</h2>
                <p>
                  The content and works on these pages created by the site operators are subject to German copyright law. 
                  The duplication, processing, distribution, and any kind of exploitation outside the limits of copyright 
                  require the written consent of the respective author or creator. Downloads and copies of this site are only 
                  permitted for private, non-commercial use.
                </p>
                <p className="mt-2">
                  Insofar as the content on this site was not created by the operator, the copyrights of third parties are 
                  respected. In particular, third-party content is marked as such. Should you nevertheless become aware of a 
                  copyright infringement, please inform us accordingly. Upon notification of violations, we will remove 
                  such content immediately.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Imprint;
